/* eslint-disable */
import React from 'react';

export const Image = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
  return <img {...props} alt={props?.alt || ''} />;
};
